/**
 * Global scroll-reveal — IntersectionObserver toggles .is-visible
 */
(function () {
  'use strict';

  var SELECTOR = '.reveal-on-scroll';
  var VISIBLE = 'is-visible';
  var ROOT_MARGIN = '0px 0px -6% 0px';
  var THRESHOLD = 0.12;

  function observeElements(observer) {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.dataset.revealObserved === 'true') return;
      el.dataset.revealObserved = 'true';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        el.classList.add(VISIBLE);
        return;
      }
      observer.observe(el);
    });
  }

  function init() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll(SELECTOR).forEach(function (el) {
        el.classList.add(VISIBLE);
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add(VISIBLE);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: ROOT_MARGIN, threshold: THRESHOLD }
    );

    observeElements(observer);

    document.addEventListener('shopify:section:load', function () {
      observeElements(observer);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
